var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "124px",
    height: "127px",
    viewBox: "0 0 124 127",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Token-All") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 62,
    cy: 62,
    r: 62
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.2%",
    y: "-1.2%",
    width: "102.4%",
    height: "104.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,14 L15,14 L15,17 L0,17 L0,14 Z M18.5,14 L20,14 L20,17 L18.5,17 L18.5,14 Z M16,14 L17.5,14 L17.5,17 L16,17 L16,14 Z M16.85,5.73 C17.47,5.12 17.85,4.28 17.85,3.35 C17.85,1.5 16.35,0 14.5,0 L14.5,1.5 C15.52,1.5 16.35,2.33 16.35,3.35 C16.35,4.37 15.52,5.2 14.5,5.2 L14.5,6.7 C16.74,6.7 18.5,8.53 18.5,10.77 L18.5,13 L20,13 L20,10.76 C20,8.54 18.72,6.62 16.85,5.73 L16.85,5.73 Z M14.03,8.2 L12.5,8.2 C11.48,8.2 10.65,7.22 10.65,6.2 C10.65,5.18 11.48,4.45 12.5,4.45 L12.5,2.95 C10.65,2.95 9.15,4.45 9.15,6.3 C9.15,8.15 10.65,9.65 12.5,9.65 L14.03,9.65 C15.08,9.65 16,10.39 16,11.7 L16,13 L17.5,13 L17.5,11.36 C17.5,9.55 15.9,8.2 14.03,8.2 L14.03,8.2 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.67,2 L7,2 L7,0 L3,0 L3,2 L1.33,2 C0.6,2 0,2.6 0,3.33 L0,18.66 C0,19.4 0.6,20 1.33,20 L8.66,20 C9.4,20 10,19.4 10,18.67 L10,3.33 C10,2.6 9.4,2 8.67,2 L8.67,2 Z M4,18 L4,12.5 L2,12.5 L6,5 L6,10.5 L8,10.5 L4,18 L4,18 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,9 L2,16 L5,16 L5,9 L2,9 L2,9 Z M8,9 L8,16 L11,16 L11,9 L8,9 L8,9 Z M0,21 L19,21 L19,18 L0,18 L0,21 L0,21 Z M14,9 L14,16 L17,16 L17,9 L14,9 L14,9 Z M9.5,0 L0,5 L0,7 L19,7 L19,5 L9.5,0 L9.5,0 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-10",
    points: "8 17 8 11 12 11 12 17 17 17 17 9 20 9 10 0 0 9 3 9 3 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,0.01 L2,0 C0.9,0 0,0.9 0,2 L0,20 C0,21.1 0.9,22 2,22 L12,22 C13.1,22 14,21.1 14,20 L14,2 C14,0.9 13.1,0.01 12,0.01 L12,0.01 Z M12,18 L2,18 L2,4 L12,4 L12,18 L12,18 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,4 L10,0 L0,0 L0,18 L20,18 L20,4 L10,4 L10,4 Z M4,16 L2,16 L2,14 L4,14 L4,16 L4,16 Z M4,12 L2,12 L2,10 L4,10 L4,12 L4,12 Z M4,8 L2,8 L2,6 L4,6 L4,8 L4,8 Z M4,4 L2,4 L2,2 L4,2 L4,4 L4,4 Z M8,16 L6,16 L6,14 L8,14 L8,16 L8,16 Z M8,12 L6,12 L6,10 L8,10 L8,12 L8,12 Z M8,8 L6,8 L6,6 L8,6 L8,8 L8,8 Z M8,4 L6,4 L6,2 L8,2 L8,4 L8,4 Z M18,16 L10,16 L10,14 L12,14 L12,12 L10,12 L10,10 L12,10 L12,8 L10,8 L10,6 L18,6 L18,16 L18,16 Z M16,8 L14,8 L14,10 L16,10 L16,8 L16,8 Z M16,12 L14,12 L14,14 L16,14 L16,12 L16,12 Z",
    id: "path-14"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\"ESG\"-Game-Screens",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ESG/S/Q1-b/Q2-b/Q3",
    transform: "translate(-54.000000, -502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(24.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(0.000000, 408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Token-All",
    transform: "translate(30.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 15.000000)",
    id: "ic_favorite"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L15,0 L15,1 L18,1 L18,3 L15,3 L15,5 L18,5 L18,7 L15,7 L15,9 L18,9 L18,11 L15,11 L15,13 L18,13 L18,15 L15,15 L15,16 L3,16 L3,15 L0,15 L0,13 L3,13 L3,11 L0,11 L0,9 L3,9 L3,7 L0,7 L0,5 L3,5 L3,3 L0,3 L0,1 L3,1 L3,0 M8,11 L8,14 L9,14 L9,11 L8,11 M10,11 L10,14 L11,14 L11,11 L10,11 M12,11 L12,14 L13,14 L13,11 L12,11 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,7 L14,9 L6,9 L6,7 L8,7 L8,6 L2,6 L2,8 L0,8 L0,0 L2,0 L2,2 L10,2 C11.1045695,2 12,2.8954305 12,4 L12,7 L14,7 M8,13 L8,16 C8,17.1045695 8.8954305,18 10,18 L18,18 L18,20 L20,20 L20,12 L18,12 L18,14 L12,14 L12,13 L14,13 L14,11 L6,11 L6,13 L8,13 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.06,22 L18.72,22 C19.56,22 20.25,21.35 20.35,20.53 L22,4.05 L17,4.05 L17,0 L15.03,0 L15.03,4.05 L10.06,4.05 L10.36,6.39 C12.07,6.86 13.67,7.71 14.63,8.65 C16.07,10.07 17.06,11.54 17.06,13.94 L17.06,22 M0,21 L0,20 L15.03,20 L15.03,21 C15.03,21.54 14.58,22 14,22 L1,22 C0.45,22 0,21.54 0,21 M15.03,14 C15.03,6 0,6 0,14 L15.03,14 M0,16 L15,16 L15,18 L0,18 L0,16 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.000000, 73.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,11.77 C5.36777958,12.3389313 5.00676356,13.1494793 5.00676356,14 C5.00676356,14.8505207 5.36777958,15.6610687 6,16.23 L6,18 C6,19.1045695 5.1045695,20 4,20 L2,20 C0.8954305,20 0,19.1045695 0,18 L0,16.23 C0.632220421,15.6610687 0.993236436,14.8505207 0.993236436,14 C0.993236436,13.1494793 0.632220421,12.3389313 0,11.77 L0,7 C0.996559195,5.49404422 1.64871485,3.78683046 1.91,2 L1,2 L1,0 L5,0 L5,2 L4.09,2 C4.35128515,3.78683046 5.00344081,5.49404422 6,7 L6,11.77 Z",
    id: "Path",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#575F69",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,7 C13.4477153,7 13,6.55228475 13,6 C13,5.44771525 13.4477153,5 14,5 C14.5522847,5 15,5.44771525 15,6 C15,6.55228475 14.5522847,7 14,7 M8,7 L2,7 L2,2 L8,2 M15.77,4.23 L15.78,4.22 L12.06,0.5 L11,1.56 L13.11,3.67 C12.17,4 11.5,4.93 11.5,6 C11.5,7.38071187 12.6192881,8.5 14,8.5 C14.36,8.5 14.69,8.42 15,8.29 L15,15.5 C15,16.0522847 14.5522847,16.5 14,16.5 C13.4477153,16.5 13,16.0522847 13,15.5 L13,11 C13,9.89 12.1,9 11,9 L10,9 L10,2 C10,0.89 9.1,0 8,0 L2,0 C0.89,0 0,0.89 0,2 L0,18 L10,18 L10,10.5 L11.5,10.5 L11.5,15.5 C11.5,16.8807119 12.6192881,18 14,18 C14.6630412,18 15.298926,17.7366079 15.767767,17.267767 C16.2366079,16.798926 16.5,16.1630412 16.5,15.5 L16.5,6 C16.5,5.31 16.22,4.68 15.77,4.23 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.000000, 49.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,12 C0,13.3 0.8,14.4 2,14.8 L2,18 L0,18 L0,20 L6,20 L6,18 L4,18 L4,14.8 C5.2,14.4 6,13.3 6,12 L6,4 L0,4 L0,12 M2,6 L4,6 L4,9 L2,9 L2,6 M17.6,6.5 L16.6,6.2 C16.3,6.1 16,5.7 16,5.3 L16,1 C16,0.5 15.5,0 15,0 L12,0 C11.4,0 11,0.5 11,1 L11,5.3 C11,5.7 10.7,6.1 10.3,6.3 L9.4,6.6 C8.6,6.9 8,7.6 8,8.5 L8,18 C8,19.1 8.9,20 10,20 L17,20 C18.1,20 19,19.1 19,18 L19,8.4 C19,7.6 18.5,6.8 17.6,6.5 M13,2 L14,2 L14,3 L13,3 L13,2 M10,8.4 L10.9,8.1 C12.2,7.7 13,6.6 13,5.3 L13,5 L14,5 L14,5.3 C14,6.6 14.8,7.7 16,8.1 L17,8.4 L17,10 L10,10 L10,8.4 M17,18 L10,18 L10,16 L17,16 L17,18 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5,0 C2.46243388,0 0,2.46243388 0,5.5 C0,6 0.09,6.5 0.22,7 L4.3,7 L5.57,3.63 C5.87,2.83 7.05,2.75 7.43,3.63 L9.5,9 L10.09,7.58 C10.22,7.25 10.57,7 11,7 L19.78,7 C19.91,6.5 20,6 20,5.5 C20,2.46243388 17.5375661,0 14.5,0 C12.64,0 11,0.93 10,2.34 C9,0.93 7.36,0 5.5,0 L5.5,0 M1,8.5 C0.44771525,8.5 0,8.94771525 0,9.5 C0,10.0522847 0.44771525,10.5 1,10.5 L3.44,10.5 L9,16 C10,16.9 10,16.9 11,16 L16.56,10.5 L19,10.5 C19.5522847,10.5 20,10.0522847 20,9.5 C20,8.94771525 19.5522847,8.5 19,8.5 L11.4,8.5 L10.47,10.8 C10.07,11.81 8.92,11.67 8.55,10.83 L6.5,5.5 L5.54,7.83 C5.39,8.21 5.05,8.5 4.6,8.5 L1,8.5 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.000000, 51.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08,1 L22.08,1 L22.08,5 L21.08,5 L21.08,6 L15.08,6 C14.5277153,6 14.08,6.44771525 14.08,7 L14.08,8 C14.08,9.1045695 13.1845695,10 12.08,10 L8.7,10 C8.32,10 7.97,10.22 7.8,10.56 L5.35,15.45 C5.18,15.79 4.84,16 4.46,16 L1.08,16 C1.08,16 -1.92,16 2.08,10 C2.08,10 5.08,6 1.08,6 L1.08,1 L2.08,1 L2.58,0 L5.58,0 L6.08,1 M13.08,8 L13.08,7 C13.08,6.44771525 12.6322847,6 12.08,6 L11.08,6 C11.08,6 10.08,7 11.08,8 C9.9754305,8 9.08,7.1045695 9.08,6 C8.52771525,6 8.08,6.44771525 8.08,7 L8.08,8 C8.08,8.55228475 8.52771525,9 9.08,9 L12.08,9 C12.6322847,9 13.08,8.55228475 13.08,8 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,6 L3.5,1.5 L14.5,1.5 L16,6 M14.5,11 C13.6715729,11 13,10.3284271 13,9.5 C13,8.67157288 13.6715729,8 14.5,8 C15.3284271,8 16,8.67157288 16,9.5 C16,10.3284271 15.3284271,11 14.5,11 M3.5,11 C2.67157288,11 2,10.3284271 2,9.5 C2,8.67157288 2.67157288,8 3.5,8 C4.32842712,8 5,8.67157288 5,9.5 C5,10.3284271 4.32842712,11 3.5,11 M15.92,1 C15.72,0.42 15.16,0 14.5,0 L3.5,0 C2.84,0 2.28,0.42 2.08,1 L0,7 L0,15 C0,15.5522847 0.44771525,16 1,16 L2,16 C2.55228475,16 3,15.5522847 3,15 L3,14 L15,14 L15,15 C15,15.5522847 15.4477153,16 16,16 L17,16 C17.5522847,16 18,15.5522847 18,15 L18,7 L15.92,1 Z",
    id: "Shape",
    fill: "#575F69"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(72.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.23759367,16.9 L2.57759367,17.46 L2.57759367,8.43 L0.147593672,14.29 C-0.262406328,15.31 0.207593672,16.48 1.23759367,16.9 M20.7375937,13.2 L15.7775937,1.25 C15.4675937,0.48 14.7375937,0.02 13.9675937,0 C13.7075937,0 13.4375937,0.04 13.1775937,0.15 L5.80759367,3.2 C5.05759367,3.51 4.59759367,4.25 4.57759367,5 C4.56759367,5.25 4.61759367,5.54 4.70759367,5.8 L9.70759367,17.75 C9.99759367,18.53 10.7375937,18.99 11.5175937,19 C11.7775937,19 12.0375937,18.95 12.2875937,18.85 L19.6475937,15.8 C20.6675937,15.38 21.1575937,14.21 20.7375937,13.2 M6.58759367,6 C6.03530892,6 5.58759367,5.55228475 5.58759367,5 C5.58759367,4.44771525 6.03530892,4 6.58759367,4 C7.13759367,4 7.58759367,4.45 7.58759367,5 C7.58759367,5.55 7.13759367,6 6.58759367,6 M4.58759367,17 C4.58759367,18.1045695 5.48302417,19 6.58759367,19 L8.03759367,19 L4.58759367,10.66 L4.58759367,17 Z",
    id: "Shape",
    fill: "#575F69"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M62,-1 C79.3969696,-1 95.1469696,6.05151519 106.547727,17.4522728 C117.948485,28.8530304 125,44.6030304 125,62 C125,79.3969696 117.948485,95.1469696 106.547727,106.547727 C95.1469696,117.948485 79.3969696,125 62,125 C44.6030304,125 28.8530304,117.948485 17.4522728,106.547727 C6.05151519,95.1469696 -1,79.3969696 -1,62 C-1,44.6030304 6.05151519,28.8530304 17.4522728,17.4522728 C28.8530304,6.05151519 44.6030304,-1 62,-1 Z M62,9 C47.3644541,9 34.1144541,14.9322271 24.5233406,24.5233406 C14.9322271,34.1144541 9,47.3644541 9,62 C9,76.6355459 14.9322271,89.8855459 24.5233406,99.4766594 C34.1144541,109.067773 47.3644541,115 62,115 C76.6355459,115 89.8855459,109.067773 99.4766594,99.4766594 C109.067773,89.8855459 115,76.6355459 115,62 C115,47.3644541 109.067773,34.1144541 99.4766594,24.5233406 C89.8855459,14.9322271 76.6355459,9 62,9 Z",
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    fill: "#4BD5AD",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenAll);
export default __webpack_public_path__ + "static/media/Token-All.55421a1f9035e3d703757dd168ae6703.svg";
export { ForwardRef as ReactComponent };